import { Link } from 'react-router'
import type { ReactNode } from 'react'

import type { TextRole } from './tokens'
import './system.css'

export function TextLink({
  to,
  role = 'label',
  children,
}: {
  to: string
  role?: TextRole
  children: ReactNode
}) {
  return (
    <Link className={`textlink text text--${role} text--accent`} to={to} viewTransition>
      {children}
    </Link>
  )
}
